import { Component, DestroyRef, inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Blueprint } from 'src/app/models/blueprints/blueprint';
import { Constants } from 'src/app/models/constants';
import { Instance } from 'src/app/models/instance/instance';
import { RouterSegments } from 'src/app/models/router-segments';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { ComponentsService } from 'src/app/services/api/components.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { InstallationSpecificationService } from 'src/app/services/util/installation-specification.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { EditRunbookService } from 'src/app/services/api/edit-runbook.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import cloneDeep from 'lodash/cloneDeep';
import { RunbookPopupComponent } from '../../environment-runbook/runbook-popup/runbook-popup.component';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { Timezone } from 'src/app/models/timezone/timezone';
import { getCurrentDateTimeAtOffset, getUtcOffsetMinutes } from 'src/app/services/util/timezone.utils';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import moment from 'moment';

@Component({
  selector: 'app-create-schedule',
  templateUrl: './create-schedule.component.html',
  styleUrl: './create-schedule.component.scss',
  standalone: false
})
export class CreateScheduleComponent {
  private destroyRef = inject(DestroyRef);

  components: any;
  selectedComponent: any;
  versions = [];
  filteredComponents: any;
  searchValue: any;
  componentsLoading = true;
  runbooks: any;
  breadcrumbItems: any;
  RouterSegments = RouterSegments;
  instance: Instance;
  blueprint: Blueprint;
  currentStep = -1;
  scheduleForm: FormGroup;
  runbookForm: FormGroup;
  occurenceForm: FormGroup;
  detailsForm: FormGroup;
  Constants = Constants;
  summaryVisited = false;
  minDate: Date;
  minEndDate: Date;
  maxStartDate: Date;
  daysSelect: boolean;
  hideEndTime: boolean;
  recurEvery = true;
  showDays: boolean;
  showMonths: boolean;
  startDateOption: any;
  cronValue: any;
  weekDaysSelected: string;
  monthCountSelected: string;
  onSelect: boolean;
  startTime: string;
  endTime: string;
  selectedRunbook: any;
  selectedRunbookName: any;
  selectedRunbookType: any;
  createScheduleData: any;
  defaultRunbookName: any;
  defaultRunbookAction: any;
  defaultRunbookVersion: any;
  createViaRunbook: boolean;
  filteredRunbooks: any;
  schedules: any;
  selectedOnSpecificDay: any;
  selectedOnDay: any;
  selectedData: any;
  timezones: Timezone[] = [];
  filteredTimezones: Timezone[] = [];
  timezoneSearchValue: string | undefined;
  isAWS: boolean;

   cronHeader: any = [
    {
      label: 'Daily',
      value: 'daily',
      data: 'cron',
      disabled: false
    },
    {
      label: 'Weekly',
      value: 'weekly',
      data: 'cron',
      disabled: false
    },
    {
      label: 'Monthly',
      value: 'monthly',
      data: 'cron',
      disabled: false
    }
  ];

  monthOptions: any = [
    {
      label: 'Days',
      value: 'days'
    },
    {
      label: 'On',
      value: 'on'
    }
  ];

   days: any = [
    {
      name: 'All',
      value: '*',
      checked: false
    },
    {
      name: 'Sunday',
      value: 'SUN',
      checked: false
    },
    {
      name: 'Monday',
      value: 'MON',
      checked: false
    },
    {
      name: 'Tuesday',
      value: 'TUE',
      checked: false
    },
    {
      name: 'Wednesday',
      value: 'WED',
      checked: false
    },
    {
      name: 'Thursday',
      value: 'THU',
      checked: false
    },
    {
      name: 'Friday',
      value: 'FRI',
      checked: false
    },
    {
      name: 'Saturday',
      value: 'SAT',
      checked: false
    },
  ];
  months: any = [
    {
      name: 'All',
      value: '*',
      checked: false
    },
    {
      name: 'Jan',
      value: 'JAN',
      checked: false
    },
    {
      name: 'Feb',
      value: 'FEB',
      checked: false
    },
    {
      name: 'Mar',
      value: 'MAR',
      checked: false
    },
    {
      name: 'Apr',
      value: 'APR',
      checked: false
    },
    {
      name: 'May',
      value: 'MAY',
      checked: false
    },
    {
      name: 'Jun',
      value: 'JUN',
      checked: false
    },
    {
      name: 'Jul',
      value: 'JUL',
      checked: false
    },
    {
      name: 'Aug',
      value: 'AUG',
      checked: false
    },
    {
      name: 'Sep',
      value: 'SEP',
      checked: false
    },
    {
      name: 'Oct',
      value: 'OCT',
      checked: false
    },
    {
      name: 'Nov',
      value: 'NOV',
      checked: false
    },
    {
      name: 'Dec',
      value: 'DEC',
      checked: false
    },
  ];

  selectedFilter: any =  {
    label: 'Daily',
    value: 'daily',
    data: 'cron'
  };

   selectedMonthFilter: any =  {
    label: 'Days',
    value: 'days'
  };

   numbers: number[] = [];
  onDaysOptions: any = [
    {name: 'First',value: '#1',checked: false},
    {name: 'Second',value: '#2',checked: false},
    {name: 'Third',value: '#3',checked: false},
    {name: 'Fourth',value: '#4',checked: false},
    {name: 'Last',value: 'L',checked: false},
  ];
  onSpecificDaysOptions: any = [
    { name: 'Sunday', value: 'SUN', checked: false },
    { name: 'Monday', value: 'MON', checked: false },
    { name: 'Tuesday', value: 'TUE', checked: false },
    { name: 'Wednesday', value: 'WED', checked: false },
    { name: 'Thursday', value: 'THU', checked: false },
    { name: 'Friday', value: 'FRI', checked: false },
    { name: 'Saturday', value: 'SAT', checked: false }
  ];

    visitedSteps = {
    stepOne: true,
    stepTwo: false,
    stepThree: false,
    stepFour: false
  };
  isEditFlow = false;
  scheduleDetails: any;

  constructor(private formBuilder: FormBuilder, public authService: AuthService,
    private router: Router, public activatedRoute: ActivatedRoute, private toastrService: CustomToastrService,
    private instanceService: InstancesService, private blueprintsService: BlueprintsService,
    private sidenavService: SidenavService, private componentService: ComponentsService,
    private dialog: MatDialog, private installationSpecificationService: InstallationSpecificationService,
    private runbookService: RunbookService, private envScheduleService: EnvScheduleService, private editRunbookService: EditRunbookService, public datepipe: DatePipe, private tenantService: TenantService) {

    this.numbers = Array.from({ length: 31 }, (_, i) => i + 1);
  }

  ngOnInit(): void {
    this.isEditFlow = this.router.url.includes('edit');
    this.createViaRunbook = this.editRunbookService.getIsEdit();
    this.createScheduleData = this.editRunbookService.getData();
    
    this.detailsForm = this.formBuilder.group({
      name: [undefined, [Validators.required,Validators.minLength(3),
        Validators.pattern(/^[A-Za-z0-9._-]+$/),Validators.maxLength(36)]],
      description: [undefined, [Validators.required]],
    });
    this.occurenceForm = this.formBuilder.group({
      timezoneId: [undefined],
      startDate: ['', [Validators.required]],
      monthDays: [''],
      sdHours: ['0'],
      edHours: ['0'],
      sdMinutes: ['0'],
      endDate: ['', [Validators.required]],
      edMinutes: ['0'],
      recurDays: ['1']
    });
    this.minDate = new Date();
    this.minEndDate = new Date();
    this.minEndDate.setDate(this.minDate.getDate() + 1);
    this.daysSelect = true;

     this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    this.runbookForm = this.formBuilder.group({
      runbookName: [undefined, [Validators.required]]
      // componentName: [undefined, [Validators.required]],
      // componentVersion: [undefined, [Validators.required]]
    });
    this.breadcrumbItems = [
      { icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.activatedRoute.snapshot.params.id]},
      { label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url:[RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION]}
    ];
    if(this.isEditFlow) {
      this.recurEvery = false;
      this.getSelectedSchedule();
    }
    this.getInstanceDetails();
    this.getComponents();
    this.getRunbooks();
    this.fetchSchedule();
    this.tenantService.tenantData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.isAWS = data === CloudProvider.AWS;
        if (!this.isAWS && !this.isEditFlow) {
          this.occurenceForm.get('timezoneId').setValidators([Validators.required]);
          this.occurenceForm.get('timezoneId').updateValueAndValidity();
        }
        if (this.isAWS && !this.isEditFlow) {
          this.setDefaultStartDateTime(0);
        }
      });
    this.getTimezones();
  }

  // to load timezones for the occurrence timezone dropdown
  getTimezones(): void {
    this.envScheduleService.getTimezones()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.timezones = response?.timezones ?? [];
        this.filteredTimezones = this.timezones;
        this.applyEditTimezoneMinDate();
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  get selectedTimezone(): Timezone | undefined {
    const timezoneId = this.occurenceForm?.get('timezoneId')?.value;
    return this.timezones.find(timezone => timezone.id === timezoneId);
  }

  searchTimezone(value: string | undefined): void {
    const term = (value ?? '').toLowerCase();
    this.filteredTimezones = this.timezones.filter(item => item?.displayName?.toLowerCase().includes(term));
  }

  resetTimezoneFilter(): void {
    this.timezoneSearchValue = undefined;
    this.filteredTimezones = this.timezones;
  }

  onTimezoneChange(timezoneId: string): void {
    const offsetMinutes = getUtcOffsetMinutes(this.timezones.find(timezone => timezone.id === timezoneId)?.displayName);
    if (offsetMinutes === null) {
      return;
    }
    if (this.isEditFlow) {
      this.minDate = getCurrentDateTimeAtOffset(offsetMinutes).date;
      return;
    }
    this.setDefaultStartDateTime(offsetMinutes);
  }

  // Defaults the start date and time to the current moment at the given UTC offset.
  setDefaultStartDateTime(offsetMinutes: number): void {
    const zoned = getCurrentDateTimeAtOffset(offsetMinutes);
    this.minDate = zoned.date;
    this.occurenceForm.patchValue({
      startDate: zoned.date,
      sdHours: zoned.hours,
      sdMinutes: zoned.minutes
    });
    this.startDateChange({ value: zoned.date });
  }

  // Method to get the scheduler details for update.
  getSelectedSchedule(): void {
    const scheduleId = this.activatedRoute.snapshot.params.scheduleId
    this.envScheduleService.getScheduleDetails(this.activatedRoute.snapshot.params.instanceId, scheduleId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.scheduleDetails = response;
        this.editSchedule();
      },
      (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '280px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('SCHEDULE.GET_SCHEDULE_DETAILS_FAILED'),
            description: errorMessage
          }
        });
      });
  }

  // Method to patch the values to its corresponding formcontrol.
  editSchedule(): void {
    let recurDaysValue;
    let monthDaysValue;
    let cronArray;
    cronArray = this.scheduleDetails?.cronExpression.split(" ");
    if(cronArray[3].includes('/')) {
      recurDaysValue = cronArray[3].split('/');
    }
    if(cronArray[3].includes(',')) {
      monthDaysValue = cronArray[3].split(',');
      monthDaysValue = monthDaysValue.map(Number);
    }
    if(cronArray[3].length === 1 && cronArray[3] !== '*' && cronArray[3] !== '?') {
      monthDaysValue = [parseInt(cronArray[3])];
    }
    if(cronArray[4] !== '*') {
      const monthDays = cronArray[4].split(',');
      monthDays.forEach(day => {
        this.months.find(item => {
          if(item.value === day) {
            item.checked = true;
          }
        })
      })
      this.monthCountSelected = monthDays.toString();
    }
    if(cronArray[5]) {
      if(cronArray[5].includes('L') || cronArray[5].includes('#')) {
        if(cronArray[5].includes('L')) {
          const cronValue = cronArray[5].split('L');
          this.onDaysOptions[4].checked = true;
          this.onSpecificDaysOptions.find(item => {
            if(item.value === cronValue[0]) {
              item.checked = true;
            }
          })
        } else {
          const cronValue = cronArray[5].split('#');
          this.onSpecificDaysOptions.find(item => {
            if(item.value === cronValue[0]) {
              item.checked = true;
            }
          })
          this.onDaysOptions.find(item => {
            if(item.value.split('#')[1] === cronValue[1]) {
              item.checked = true;
            }
          })
        }
      }
      else {
        let weeksDays = [];
        weeksDays = cronArray[5].split(',');
        weeksDays.forEach(day => {
          this.days.find(item => {
            if(item.value === day) {
              item.checked = true;
            }
          })
        })
        this.weekDaysSelected = weeksDays.toString();
      }
    }
    this.detailsForm.patchValue({
      name: this.scheduleDetails?.name.split('-') ? this.scheduleDetails?.name.split('-')[0] : this.scheduleDetails?.name,
      description: this.scheduleDetails?.description
    });
    this.occurenceForm.patchValue({
      monthDays: monthDaysValue,
      recurDays: recurDaysValue ? recurDaysValue[1] : ['1'],
      timezoneId: this.scheduleDetails?.timezoneId
    });

    if((cronArray[4] !== '*' && cronArray[4] !== '?') || cronArray[3].includes(',') || (cronArray[3].length === 1 && cronArray[3] !== '?' && cronArray[3] !== '*')  || cronArray[5].includes('#') || cronArray[5].includes('L')) {
      this.selectedFilter = this.cronHeader.find(item => item.value === 'monthly');
      this.showMonths = true;
      if (cronArray[5] !== '*' && cronArray[5] !== '?') {
        this.filterMonthOptionChange(this.monthOptions.find(item => item.value === 'on'));
      } else if (cronArray[3] !== '*') {
        this.filterMonthOptionChange(this.monthOptions.find(item => item.value === 'days'));
      }
    } else if(cronArray[5] !== '*' && cronArray[5] !== '?') {
      this.selectedFilter = this.cronHeader.find(item => item.value === 'weekly');
      this.showDays = true;
    } else if(cronArray[3] !== '*' && cronArray[3] !== '?') {
      this.selectedFilter = this.cronHeader.find(item => item.value === 'daily');
      this.recurEvery = true;
    }
    this.setRunbookDetails();
    this.occurenceForm.get('startDate').setValue(this.scheduleDetails?.startTime);
    const startTime = moment(new Date(this.scheduleDetails?.startTime)).utc();
    this.occurenceForm.get('sdHours').setValue(startTime.hours() ? startTime.hours() : ['0']);
    this.occurenceForm.get('sdMinutes').setValue(startTime.minutes() ? startTime.minutes() : ['0']);
    this.occurenceForm.get('endDate').setValue(this.scheduleDetails?.endTime);
    const endTime = moment(new Date(this.scheduleDetails?.endTime)).utc();
    this.occurenceForm.get('edHours').setValue(endTime.hours() ? endTime.hours() : ['0']);
    this.occurenceForm.get('edMinutes').setValue(endTime.minutes() ? endTime.minutes() : ['0']);
    this.applyEditTimezoneMinDate();
  }

  // Timezones and the saved schedule load asynchronously; whichever arrives last applies the minimum.
  private applyEditTimezoneMinDate(): void {
    const timezoneId = this.occurenceForm?.get('timezoneId')?.value;
    if (this.isEditFlow && timezoneId) {
      this.onTimezoneChange(timezoneId);
    }
  }

    // Providing option for enddate selection based on the start date selected bcoz end date should be higher than start date.
    startDateChange(event): void {
      this.startDateOption = event.value;
      const result = cloneDeep(new Date(this.startDateOption));
      result.setDate(result.getDate() + 1);
      this.minEndDate = result;
    }

    // Providing option for startDate selection based on the end date selected bcoz end date should be higher than start date.
    endDateChange(event): void {
      const endDateOption = event.value;
      const result = cloneDeep(new Date(endDateOption));
      result.setDate(result.getDate() - 1);
      this.maxStartDate = result;
    }

  // to get instance details
  private getInstanceDetails(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstanceDetails(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.instance = data;          
          this.getBlueprint();
        }
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  // to get blueprint details
  private getBlueprint(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const tenantId = this.activatedRoute.snapshot.params.id;
      this.blueprintsService.getBlueprints(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((blueprints: any) => {
        this.blueprint = blueprints?.find(item => item.id == blueprintId);
        this.breadcrumbItems.push(
          { label: this.blueprint?.name, url: [RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION,
            this.activatedRoute.snapshot.params.blueprintId] },
          { label: this.instance?.name, url: [RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION,
            this.activatedRoute.snapshot.params.blueprintId, RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId] },
          { label: translate('SCHEDULE.SCHEDULE'), action: () => this.goToSchedule()},
          { label: this.isEditFlow ? translate('SCHEDULE.EDIT_SCHEDULE') : translate('RUNBOOK.CREATE_SCHEDULE') }
          );
          this.editRunbookService.clearData();
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  // Occurrence tab click change
    filterOptionChange(option): void {
      this.selectedFilter = option;
      this.hideEndTime = true;
      this.recurEvery = false;
      this.showDays = false;
      this.showMonths = false;
      if(option.value === 'daily') {
        this.occurenceForm?.addControl('endDate', new FormControl('', [Validators.required]));
        this.occurenceForm.get('endDate').setValue(this.selectedData?.endTime);
        this.recurEvery = true;
      } else if(option.value === 'weekly') {
        this.occurenceForm?.addControl('endDate', new FormControl('', [Validators.required]));
        this.occurenceForm.get('endDate').setValue(this.selectedData?.endTime);
        this.showDays = true;
      } else if(option.value === 'monthly') {
        this.occurenceForm?.addControl('endDate', new FormControl('', [Validators.required]));
        this.occurenceForm.get('endDate').setValue(this.selectedData?.endTime);
        this.showMonths = true;
      }
    }

    //Occurrence tab month option click.
    filterMonthOptionChange(option): void {
      this.selectedMonthFilter = option;
      if(option.value === 'days') {
        this.occurenceForm.removeControl('onDays');
        this.occurenceForm.removeControl('onSpecificDays');
        this.daysSelect = true;
        this.onSelect = false;
      } else {
        this.occurenceForm.addControl('onDays', new FormControl('', [Validators.required]));
        this.occurenceForm.addControl('onSpecificDays', new FormControl('', [Validators.required]));
        this.occurenceForm?.get('onSpecificDays').setValue(this.onSpecificDaysOptions.find(item => item.checked));
        this.occurenceForm?.get('onDays').setValue(this.onDaysOptions.find(item => item.checked));
        this.daysSelect = false;
        this.onSelect = true;
      }
    }

goToStep(step): void {
    const goingBackward = step < this.currentStep;
    if (!goingBackward && this.currentStep === -1 && FormUtilService.validateForm(this.detailsForm)) {
      if (this.isScheduleNameInvalid() && !this.isEditFlow) {
        this.setErrorToNameControl();
        return;
      }
    }
    if (!goingBackward && ((this.currentStep === -1 && FormUtilService.validateForm(this.detailsForm)) || (this.currentStep === 0 && FormUtilService.validateForm(this.occurenceForm)) || (this.currentStep === 1 && FormUtilService.validateForm(this.runbookForm)))) {
      this.currentStep = step;
      if (this.currentStep === 0) {
   this.cronHeader.forEach(item => item.disabled = false);
      }
      if (this.currentStep === 1) {
         this.startTime =
      this.datepipe.transform(this.occurenceForm.get('startDate')?.value, 'yyyy-MM-dd')
      + 'T' +
      (this.occurenceForm.get('sdHours')?.value).toString().padStart(2, '0')
      + ':' +
      (this.occurenceForm.get('sdMinutes')?.value).toString().padStart(2, '0')
      + ':00Z';

    this.endTime =
      this.datepipe.transform(this.occurenceForm.get('endDate')?.value, 'yyyy-MM-dd')
      + 'T' +
      (this.occurenceForm.get('edHours')?.value).toString().padStart(2, '0')
      + ':' +
      (this.occurenceForm.get('edMinutes')?.value).toString().padStart(2, '0')
      + ':00Z';

    this.cronFormation();
      }
	  if (this.currentStep === 2) {
    this.summaryVisited = true;
  }
    } else if (goingBackward) {
      this.currentStep = step;
    }
  }

    // Method to convert the selection values to cron format manually.
    cronFormation(): void {
      this.cronValue = '0 0 0 * * *';
      const option = this.selectedFilter;
      if(option.value === 'daily') {
        this.cronValue = '0 ' + this.occurenceForm?.get('sdMinutes').value.toString() + ' ' + this.occurenceForm?.get('sdHours').value.toString() + ' ' +
        (this.occurenceForm?.get('recurDays').value ? '1/' + (this.occurenceForm?.get('recurDays').value.toString()) : '*') + ' ' +'* ?';
      } else if(option.value === 'weekly') {
        this.cronValue = '0 ' + this.occurenceForm?.get('sdMinutes').value.toString() + ' ' + this.occurenceForm?.get('sdHours').value.toString() + ' ' +
        '? *' + ' ' + (this.weekDaysSelected ? this.weekDaysSelected : '*');
      } else if(option.value === 'monthly') {
        if(this.selectedMonthFilter.value === 'days') {
          this.cronValue = '0 ' + this.occurenceForm?.get('sdMinutes').value.toString() + ' ' + this.occurenceForm?.get('sdHours').value.toString() + ' ' +
          (this.occurenceForm?.get('monthDays').value ? this.occurenceForm?.get('monthDays').value.toString() :'*') + ' ' + (this.monthCountSelected ? this.monthCountSelected : '*') + ' ' + '?';
        } else {
          this.cronValue = '0 ' + this.occurenceForm?.get('sdMinutes').value.toString() + ' ' + this.occurenceForm?.get('sdHours').value.toString() + ' ' +
        '?' + ' ' + (this.monthCountSelected ? this.monthCountSelected : '*') + ' ' +
        ((this.occurenceForm?.get('onSpecificDays') && this.occurenceForm?.get('onDays')) ? (this.occurenceForm?.get('onSpecificDays').value.value.toString() + this.occurenceForm.get('onDays').value.value.toString()) : '*');
        }
      } else if(option.value === 'once') {
        this.cronValue = '0 ' + this.occurenceForm?.get('sdMinutes').value.toString() + ' ' + this.occurenceForm?.get('sdHours').value.toString() + ' ' + '* * *';
      }
    }

  getRunbooks(): void {
    this.runbookService.getRunbook(this.activatedRoute.snapshot.params.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(runbooks => {
      this.runbooks = runbooks.filter(rb =>
        ['deployed', 'configured', 'updated'].includes(rb?.status?.toLowerCase())
      );
        this.filteredRunbooks = this.runbooks;
        if (this.createViaRunbook && this.createScheduleData) {
        const rb = this.runbooks?.find(r => r.name === this.createScheduleData?.name);
        if (rb) {
          this.runbookForm.get('runbookName')?.setValue(rb);
          this.selectedRunbook = rb;
        }
      }
       if (this.isEditFlow) {
        this.setRunbookDetails();
      }
      },
      (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  setRunbookDetails(): void {
    if (this.runbooks && this.scheduleDetails && this.components) {
      const runbook = this.runbooks.find(item => item.id === this.scheduleDetails?.runbookId);
      this.runbookForm?.get('runbookName').setValue(runbook);
      this.selectedRunbookType = this.components.find(item => item.name === runbook?.componentName)?.displayName;  
    }
  }
  

  // to load components
  getComponents(): void {
    this.componentsLoading = true;
    const componentType = 'runbook';
      this.componentService.getComponents(componentType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.componentsLoading = false;
        this.components = [];
        this.components = data;
        this.filteredComponents = this.components;
        this.setRunbookDetails();
        if (this.createViaRunbook && this.createScheduleData) {
        const action = this.filteredComponents
            ?.find(c => c.name === this.createScheduleData?.componentName);
            this.selectedRunbookType = action?.displayName || this.createScheduleData.componentName;

        if (action) {
          this.runbookForm.get('componentName')?.setValue(action);
        }
      }
      },
      (error) => {
        this.componentsLoading = false;
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '280px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('CUSTOM_IMAGES.GET_COMPONENTS_FAILED'),
            description: errorMessage
          }
        });
      });
  }

  onRunbookSelected(runbook: any): void {
  this.selectedRunbook = runbook;
  this.selectedRunbookName = runbook?.name || '-';
  this.selectedRunbookType = this.components.find(item => item.name === runbook.componentName)?.displayName;  
}

onActionSelected(action: any): void {
  this.selectedRunbookType = action.displayName;  
}

openRunbookDetails(): void {
this.dialog.open(RunbookPopupComponent, {
    width: '800px',
    panelClass: 'default-dialog-wrapper',
    data: {
      runbook: this.selectedRunbook || this.runbooks.find(item => item.id === this.scheduleDetails?.runbookId),
      name: this.instance?.name
    }
  });
}

// Occurrence tab specific day option selected.
specificDayOptionSelected(data): void {
  this.selectedOnSpecificDay = data;
}

// Occurrence tab day option selected.
dayOptionSelected(data): void {
  this.selectedOnDay = data;
}

  cancelClick(): void {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: this.isEditFlow ? translate('SCHEDULE.CANCEL_EDIT_SCHEDULE') : translate('RUNBOOK.CANCEL_ADD_SCHEDULE'),
          message: this.isEditFlow ? translate('SCHEDULE.CANCEL_EDIT_SCHEDULE_DESCRIPTION') : translate('RUNBOOK.CANCEL_SCHEDULE_DESCRIPTION'),
          confirmButtonText: translate('BUTTONS.YES'),
          cancelButtonText: translate('BUTTONS.NO')
        }
      }) .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.editRunbookService.clearData();
          this.goToSchedule();
        }
      })

    }

  // to navigate back to environment details page on cancel click
  goToSchedule(): void {
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId], {state: {data: 'SCHEDULES'}});
      this.editRunbookService.clearData();
  }

// Occurrence tab week days selection with 'All'.
    selectDays(data): void {
      if(data.name === 'All') {
        if(data.checked) {
        this.days.map(item => item.checked = false);
        } else {
          this.days.map(item => item.checked = true);
        }
      } else {
      this.days.find(item => {
        if(item.name === data.name) {
          item.checked = !item.checked;
          const selectedLength = this.days.filter(e => e.checked === true && e.name !== 'All');
          if(selectedLength.length === 7) {
            this.days[0].checked = true;
          } else {
            this.days[0].checked = false;
          }
        }
      })
    }
      let weeksDays = [];
      const data1 = this.days.filter(item => item.checked);
      if(data1.find(item => item.name === 'All')) {
        weeksDays.push('*');
      } else {
        data1.forEach(item => {
          weeksDays.push(item.value);
        })
      }
      this.weekDaysSelected = weeksDays.toString();
    }

     // Occurrence tab months selection with 'All'.
    selectMonths(data): void {
      this.months.find(item => {
        if(data.name === 'All') {
          if(data.checked) {
          this.months.map(item => item.checked = false);
          } else {
            this.months.map(item => item.checked = true);
          }
        }
        else if(item.name === data.name) {
          item.checked = !item.checked;
          const selectedLength = this.months.filter(e => e.checked === true && e.name !== 'All');
          if(selectedLength.length === 12) {
            this.months[0].checked = true;
          } else {
            this.months[0].checked = false;
          }
        }
      })
      let monthsCount = [];
      const data1 = this.months.filter(item => item.checked);
      if(data1.find(item => item.name === 'All')) {
        monthsCount.push('*');
      } else {
        data1.forEach(item => {
          monthsCount.push(item.value);
        })
      }
      this.monthCountSelected = monthsCount.toString();
    }


  // assign the selected component
  componentSelection(event): void {
    this.selectedComponent = event.value;
    this.versions = this.components.filter(item => item.name === this.selectedComponent.name);
    const versionsSorted = this.versions.sort((a,b) => a.dateCreated < b.dateCreated ? 1 : a.dateCreated > b.dateCreated ? -1 : 0);
    this.runbookForm?.get('componentVersion').setValue(versionsSorted[0]);    
  }

  // searching components dropdown
  searchChanged(value): void {
    this.filteredComponents = this.components.filter(item => item?.name?.toLowerCase().includes(value.toLowerCase()));
  }

  searchRunbookName(value): void {
    this.filteredRunbooks = this.runbooks.filter(item => item?.name?.toLowerCase().includes(value.toLowerCase()));
 }

  // resetting dropdown values when dropdown is closed
  dropdownClose(): void {
    if (this.filteredComponents?.length === 0) {
      this.filteredComponents = this.components;
    } else if (this.filteredRunbooks?.length === 0) {
      this.filteredRunbooks = this.runbooks;
     }
  }

  // resetting search filter of components dropdown when dropdown is closed
  resetFilter(): void {
    this.searchValue = undefined;
    this.filteredComponents = this.components;
    this.filteredRunbooks = this.runbooks;
  }

  submit(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('RUNBOOK.CREATE_SCHEDULE'),
        message: translate('RUNBOOK.CREATE_SCHEDULE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        const instanceId = this.activatedRoute.snapshot.params.instanceId;
        if (confirm) {
        const obj = {
          id: this.activatedRoute.snapshot.params.instanceId,
          name: this.detailsForm?.get('name')?.value,
          description: this.detailsForm?.get('description')?.value,
          runbookName: this.runbookForm?.get('runbookName')?.value?.name,
          cronExpression: this.cronValue,
          startTime: this.startTime,
          endTime: this.endTime,
          ...(this.isAWS ? {} : { timezoneId: this.occurenceForm?.get('timezoneId')?.value })
        }
          this.envScheduleService.postSchedule(obj).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            const tenantId = this.activatedRoute.snapshot.params.id;
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
              RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId], {state: {data: 'SCHEDULES'}});
              this.editRunbookService.clearData();
            setTimeout(() => {
              const title = translate('RUNBOOK.CREATE_SCHEDULE');
              const message = translate('SCHEDULE.CREATE_SCHEDULE_TRIGGERED');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('SCHEDULE.CREATE_SCHEDULE_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      });
  }

  fetchSchedule(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.envScheduleService.getSchedule(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          response = response?.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
          this.schedules = response;
        },
         (error) => {
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
    }

  private isScheduleNameInvalid(): any {
    const currentScheduleName = this.detailsForm.get('name').value?.toLowerCase();
    return this.schedules?.some(schedule => schedule?.name?.toLowerCase() === currentScheduleName);
  }

   private setErrorToNameControl(): void {
    setTimeout(() => this.detailsForm.get('name').setErrors({nameNotUnique: true}));
  }

  editSubmit(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULE.EDIT_SCHEDULE'),
        message: translate('SCHEDULE.EDIT_SCHEDULE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        const instanceId = this.activatedRoute.snapshot.params.instanceId;
        if (confirm) {
        const obj = {
          id: this.activatedRoute.snapshot.params.instanceId,
          scheduleId: this.activatedRoute.snapshot.params.scheduleId,
          cronExpression: this.cronValue,
          startTime: this.startTime,
          endTime: this.endTime,
          ...(this.isAWS ? {} : { timezoneId: this.occurenceForm?.get('timezoneId')?.value })
        }
          this.envScheduleService.putSchedule(obj).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            const tenantId = this.activatedRoute.snapshot.params.id;
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
              RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId], {state: {data: 'SCHEDULES'}});
              this.editRunbookService.clearData();
            setTimeout(() => {
              const title = translate('SCHEDULE.EDIT_SCHEDULE');
              const message = translate('SCHEDULE.EDIT_SCHEDULE_TRIGGERED');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('SCHEDULE.EDIT_SCHEDULE_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      });
  }
}
